import React from 'react';

import { apiAddCEU } from '../../../../api/ceu';
import { routes } from '../../../index';

import CEU from './CEU';

export default (props) => (
  <CEU submit={apiAddCEU} finish={() => props.history.push(routes.ceus.individual.root)} {...props} />
);
